/* eslint-disable react/sort-comp */
import DeletionContext from "src/MultiDeletionFunctionality/@state/DeletionStateContext";
import DELETE_ACTIONS from "src/MultiDeletionFunctionality/@state_manager/actions";
import { ContentSwitch } from "Components";
import {
  SUBMISSIONS,
  SUPPLIES,
  SUPPLIES_EXCEL,
  TEMPLATES
} from "constants/apis";
import pageSizes from "constants/pageSizes";
import { confirmSuppliesStatus } from "helpers/confirmStatus";
import { copy, equal } from "helpers/deep";
import DownloadFromUrl from "helpers/download";
import Fetch from "helpers/fetch";
import { buildUrl } from "helpers/misc";
import { cleanSearchParams, urlSearchToObject } from "helpers/urlSearchParams";
import rowRules from "helpers/rowRules";
import menuOptions from "constants/menuOptions";
import i18n from "i18next";
import PropTypes from "prop-types";
import React from "react";
import "./Supplies.css";
import SuppliesDesktop from "./SuppliesDesktop/SuppliesDesktop";
import SuppliesMobile from "./SuppliesMobile/SuppliesMobile";

class Supplies extends React.Component {
  //! Providing the DeletionContext:
  static contextType = DeletionContext;

  constructor(props) {
    super(props);

    const searchValues = {
      "Pinned Orders": { Pinned: true },
      "My Orders": { MyOrder: true },
      "All Orders": {}
    };

    const tabs = Object.keys(searchValues);

    this.state = {
      pageSizes,
      tabs,
      searchValues,
      powerTableIndex: null
    };

    this.funcs = {
      handlePageSizeChange: this.handlePageSizeChange.bind(this),
      onPinClick: this.onPinClick.bind(this),
      onOptionClick: this.onOptionClick.bind(this),
      handlePageNumberChange: this.handlePageNumberChange.bind(this),
      handleTabClick: this.handleTabClick.bind(this),
      setPageState: this.setState.bind(this),
      onSearchDownload: this.handleSearchDownload.bind(this),
      rowRules: rowRules.order,
      //! Deletion Confirmation Functions:
      multiDeletionSubmissionHandler: this.multiDeletionSubmissionHandler.bind(
        this
      )
    };
  }

  componentDidMount() {
    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;

    this.handleSearch();
    this.props.setHeadTitle(i18n.t("head:Supplies"));

    this.dispatch({
      type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
      payload: {
        data: [],
        tableCode: "supplies",
        idName: "OrderNumber",
        selectedItems: [],
        itemsAllowedToDelete: []
      }
    });

    this.props.setAppState(prevState => ({
      isNavCollapsed: true,
      orders: {
        ...prevState.orders,
        shouldLoad: true
      }
    }));
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !equal(nextProps, this.props) || !equal(nextState, this.state);
  }

  componentDidUpdate(prevProps) {
    this.handleSearch();

    if (!this.props.data.isLoading && prevProps.data.isLoading) {
      this.switchTabs();
      //! Update the data here...
      this.dispatch({
        type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
        payload: {
          data: this.props.data.data
        }
      });

      this.dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });
    }

    if (
      this.props.location !== prevProps.location ||
      prevProps.filterItemValue !== this.props.filterItemValue
    ) {
      this.props.setHeadTitle(i18n.t("head:Supplies"));
    }
  }

  componentWillUnmount() {
    this.props.data.abortController.abort();

    this.props.setAppState(prevState => ({
      isNavCollapsed: false,
      orders: {
        ...prevState.orders,
        abortController: new AbortController()
      }
    }));
    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;
  this.dispatch({ type: DELETE_ACTIONS.RESET_DELETION_STATE });
  }

  onPinClick(index) {
    const orders = {
      ...copy(this.props.data),
      abortController: new AbortController()
    };
    const selectedSupplies = orders.data[index];
    const path = selectedSupplies.Pinned ? "Unpin" : "Pin";
    orders.data[index].Pinned = !orders.data[index].Pinned;
    this.props.setAppState({ orders });

    const URL = `${SUPPLIES}/${selectedSupplies.OrderNumber}/${path}?`;
    Fetch.Post(URL, {}).then(() => null).catch(() => null);
  }

  onOptionClick(code, i) {
    const { deletionState, dispatch } = this.context;
    const item = this.props.data.data[i];
    this.setState({ powerTableIndex: null });

    switch (code) {
      case "view":
        confirmSuppliesStatus(item)
          .then(() => {
            if (item.Status === "-2") {
              this.props.setAppState(
                {
                  formIndex: 2
                },
                this.props.history.push(
                  `/supplies/${encodeURIComponent(item.OrderNumber)}/edit`
                )
              );
            } else {
              DownloadFromUrl(
                `${SUPPLIES}/${item.OrderNumber}/GetConfirmationPDF`
              ).catch(({ response }) => this.props.onAPIError(response, true));
            }
          })
          .catch(() => this.refreshTable());

        break;
      case "edit":
        this.props.setAppState(
          {
            formIndex: 0
          },
          this.props.history.push(
            `/supplies/${encodeURIComponent(item.OrderNumber)}/edit`
          )
        );
        break;
      case "copy":
        this.props.setAppState({ isCreatingObject: true });
        if (this.props.isPrepaid) {
          Fetch.Post(`${SUBMISSIONS}/Order/${item.OrderNumber}?requireOrder=true`)
            .then(resp => resp.json())
            .then(data =>
              this.props.history.push(`/submissions/${data.DataItem.Id}/edit`)
            )
            .then(() => this.props.setAppState({ formIndex: 0, isPrepaidOrder:true }))
            .catch(({ response }) => this.props.onCopyOrderError(response, true))
            .finally(() => this.props.setAppState({ isCreatingObject: false }));
        }
        else {
          Fetch.Post(`${SUPPLIES}/${item.OrderNumber}/CopyOrder`)
            .then(resp => resp.json())
            .then(data =>
              this.props.history.push(
                `/supplies/${data.DataItem.OrderNumber}/edit`
              )
            )
            .catch(({ response }) => this.props.onCopyOrderError(response, true))
            .finally(() => this.props.setAppState({ isCreatingObject: false }));
        }
        break;
      case "newTemplate":
        this.props.setAppState({ isCreatingObject: true });
        Fetch.Post(TEMPLATES, { CopyOrderNumber: item.OrderNumber })
          .then(resp => resp.json())
          .then(data =>
            this.props.history.push(`/templates/${data.DataItem.Id}/edit`)
          )
          .then(() => this.props.setAppState({ formIndex: 0 }))
          .catch(({ response }) => this.props.onCopyOrderError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
        break;
      case "newSubmission":
        this.props.setAppState({ isCreatingObject: true });
        Fetch.Post(`${SUBMISSIONS}/Order/${item.OrderNumber}`)
          .then(resp => resp.json())
          .then(data =>
            this.props.history.push(`/submissions/${data.DataItem.Id}/edit`)
          )
          .then(() => this.props.setAppState({ formIndex: 0 }))
          .catch(({ response }) => this.props.onCopyOrderError(response, true))
          .finally(() => this.props.setAppState({ isCreatingObject: false }));
        break;
      case "cancel":
        this.props.setAppState({ isChangingObject: true });
        Fetch.Post(`${SUPPLIES}/${item.OrderNumber}/cancel`)
          .then(() =>
            this.props.setAppState(prevState => ({
              orders: {
                ...prevState.orders,
                shouldLoad: true
              }
            }))
          )
          .catch(({ response }) => this.props.onAPIError(response, true))
          .finally(() => this.props.setAppState({ isChangingObject: false }));
        break;
      case "delete":
        dispatch({
          type: DELETE_ACTIONS.UPDATE_DELETION_STATE,
          payload: { selectedItems: [item.OrderNumber] }
        });
        dispatch({ type: DELETE_ACTIONS.ACTIVATE_DELETE_CONFIRMATION });
        break;

      //! Multi Delete Option Click handler:
      case "multiDelete": {
        // const selectedItemsList = this.deletionState.selectedItems
        this.dispatch({
          type: DELETE_ACTIONS.ACTIVATE_DELETION_MODE,
          payload: { id: item.OrderNumber }
        });

        break;
      }
      case "share":
        this.props.setAppState({
          shareId: item.OrderNumber,
          shareCode: "Order"
        });
        break;

      default:
        break;
    }
  }

  handleSearchDownload() {
    const { searchType, ...globalSearchParams } = cleanSearchParams(
      urlSearchToObject(this.props.location.search)
    );

    DownloadFromUrl(
      buildUrl(SUPPLIES_EXCEL, globalSearchParams)
    ).catch(({ response }) => this.props.onAPIError(response, true));
  }

  switchTabs() {
    const { data, isLoading, isInitialized, tabIndex } = this.props.data;

    if (tabIndex === 2 || (!isInitialized && !isLoading && data.length !== 0)) {
      this.props.setAppState(prevState => ({
        orders: {
          ...prevState.orders,
          isInitialized: true
        }
      }));
    }

    if (tabIndex < 2 && !isInitialized && !isLoading && data.length === 0) {
      this.handleTabClick(tabIndex + 1);
    }
  }

  refreshTable() {
    this.props.setAppState(prevState => ({
      orders: {
        ...prevState.orders,
        shouldLoad: true
      }
    }));
  }

  handleSearch() {
    const globalSearchParams = cleanSearchParams(
      urlSearchToObject(this.props.location.search)
    );

    if (!equal(this.props.data.globalSearchParams, globalSearchParams)) {
      this.props.setAppState(prevState => ({
        orders: {
          ...prevState.orders,
          shouldLoad: true,
          tabIndex: 2,
          pageNumber: 1,
          globalSearchParams,
          searchParams: {
            ...prevState.searchParams,
            Pinned: undefined
          }
        }
      }));
    }
  }

  handleTabClick(tabIndex) {
    const { searchValues, tabs } = this.state;

    const searchParams = searchValues[tabs[tabIndex]];

    this.props.setAppState(prevState => ({
      orders: {
        ...prevState.orders,
        searchParams,
        tabIndex,
        pageNumber: 1,
        shouldLoad: this.props.data.tabIndex !== tabIndex
      }
    }));

    this.dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETION_MODE });
  }

  handlePageNumberChange(pageNumber) {
    this.props.setAppState({
      orders: {
        ...this.props.data,
        shouldLoad: true,
        pageNumber
      }
    });
  }

  handlePageSizeChange(e) {
    this.props.setAppState({
      orders: {
        ...this.props.data,
        shouldLoad: true,
        pageSize: Number(e.target.value),
        pageNumber: 1
      }
    });
  }

  multiDeletionSubmissionHandler() {
    const { deletionState, dispatch } = this.context;

    this.props.setAppState(prevState => ({
      orders: {
        ...prevState.orders,
        isLoading: true,
        isDeleting: true
      }
    }));

    Fetch.Delete(SUPPLIES, { IdList: deletionState.selectedItems })
      .then(() => {
        this.props.setAppState(prevState => ({
          orders: {
            ...prevState.orders,
            shouldLoad: true,
            isDeleting: false
          }
        }));
      })
      .catch(({ response }) => this.props.onAPIError(response, true))
      .finally(() =>
        this.props.setAppState(prevState => ({
          orders: {
            ...prevState.orders,
            isDeleting: false
          }
        }))
      );

    dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETION_MODE });
    dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION });

    // Fetch.Delete(`${SUPPLIES}/${item.OrderNumber}`)
    //   .then(() => {
    //     this.props.setAppState(prevState => ({
    //       orders: {
    //         ...prevState.orders,
    //         shouldLoad: true,
    //         isDeleting: false,
    //       },
    //     }));

    //     this.dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETION_MODE })
    //   })
    //   .catch(({ response }) => this.props.onAPIError(response, true))
    //   .finally(() => this.props.setAppState(prevState => {
    //     this.dispatch({ type: DELETE_ACTIONS.DEACTIVATE_DELETE_CONFIRMATION });
    //     return {
    //       orders: {
    //         ...prevState.orders,
    //         isDeleting: false,
    //       },
    //     }
    //   }));
  }

  render() {
    const { state, props, funcs } = this;
    const sharedProps = {
      isGlobalSearch: this.props.location.search.includes("searchType"),
      menuOptions,
      ordersSearchKeyPairs: props.ordersSearchKeyPairs
    };

    return (
      <ContentSwitch
        index={props.deviceIndex}
        {...state}
        {...props}
        {...funcs}
        {...sharedProps}
      >
        <SuppliesMobile />
        <SuppliesDesktop />
      </ContentSwitch>
    );
  }
}

Supplies.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  data: PropTypes.shape({
    isLoading: PropTypes.bool,
    abortController: PropTypes.shape({
      abort: PropTypes.func
    }),
    data: PropTypes.arrayOf(PropTypes.shape({})),
    isInitialized: PropTypes.bool,
    tabIndex: PropTypes.number,
    globalSearchParams: PropTypes.shape({})
  }),
  setAppState: PropTypes.func,
  setHeadTitle: PropTypes.func,
  filterItemValue: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  onAPIError: PropTypes.func,
  onCopyOrderError: PropTypes.func,
  isSupplyWarningON: PropTypes.bool,
  isTemplateWarningON: PropTypes.bool,
  isSubmissionWarningON: PropTypes.bool,
  isPrepaid: PropTypes.bool
};

export default Supplies;



// WEBPACK FOOTER //
// ./src/containers/Supplies/Supplies.jsx